<mat-sidenav-container class="container" autosize>
    <mat-sidenav #drawer class="interface-container-sidenav" mode="side" opened [fixedInViewport]="true">
        <app-interface-sidenav [drawer]="drawer"></app-interface-sidenav>
    </mat-sidenav>

    <div class="interface-content-container">
        <router-outlet></router-outlet>
    </div>
</mat-sidenav-container>
